import { useContext, useState } from "react";
import { HarvestLogContext } from "../store/HarvestLogContext";
import "./Modal.css";

export type HarvestLogModalBodyProps = {
  onClose: () => void;
};

export function HarvestLogModalBody({ onClose }: HarvestLogModalBodyProps) {
  const { createLog } = useContext(HarvestLogContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeLogProducts, setActiveLogProducts] = useState([
    { id: 0, product: "", quantity: 0 },
  ]);
  const [endDateData, setEndDateData] = useState("");
  function handleUpdateProduct(value: string, id: number) {
    setActiveLogProducts((prev) =>
      prev.map((item) => (item.id === id ? { ...item, product: value } : item)),
    );
  }
  function handleUpdateQuantity(value: string, id: number) {
    const valueNumber = Number(value);
    setActiveLogProducts((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, quantity: valueNumber } : item,
      ),
    );
  }

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    if (isSubmitting) return;
    const form = event.currentTarget;
    setIsSubmitting(true);
    try {
      const fd = new FormData(form);
      const data = Object.fromEntries(fd.entries());
      const id = crypto.randomUUID();
      const products = activeLogProducts
        .filter((item) => item.product.trim() !== "" && item.quantity > 0)
        .map(({ product, quantity }) => ({ product: product.trim(), quantity }));

      if (products.length === 0) return;

      const log = {
        logId: id,
        startDate: data.startDate.toString(),
        endDate: data.endDate?.toString() ?? "",
        comment: data.comment?.toString() || "",
        products,
      };

      await createLog(log);
      form.reset();
      setActiveLogProducts([{ id: 0, product: "", quantity: 0 }]);
      setEndDateData("");
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="">
      <form onSubmit={handleSubmit} className="harvest-log-form">
        <div
          role="group"
          id="date"
          aria-labelledby="date"
          className="modal-form-input-pair"
        >
          <label htmlFor="startDate" className="sr-only">
            From
          </label>
          <input
            id="startDate"
            name="startDate"
            type="date"
            placeholder="From"
            required
          />

          <label htmlFor="endDate" className="sr-only">
            To
          </label>
          <input
            className={endDateData ? "date-input-true" : "date-input"}
            id="endDate"
            name="endDate"
            type="date"
            placeholder="To"
            onChange={(e) => setEndDateData(e.target.value)}
          />
        </div>
        {activeLogProducts.map((product) => (
          <div key={product.id} className="modal-form-input-pair">
            <label htmlFor={`product-${product.id}`} className="sr-only">
              Product
            </label>
            <input
              id={`product-${product.id}`}
              type="text"
              placeholder="Product"
              value={product.product}
              onChange={(e) =>
                handleUpdateProduct(e.currentTarget.value, product.id)
              }
            />

            <label htmlFor={`quantity-${product.id}`} className="sr-only">
              Quantity
            </label>
            <input
              id={`quantity-${product.id}`}
              type="number"
              placeholder="Quantity (kg)"
              value={product.quantity ? product.quantity : ""}
              onChange={(e) =>
                handleUpdateQuantity(e.currentTarget.value, product.id)
              }
            />
          </div>
        ))}

        <label htmlFor="comment" className="sr-only">
          Comment
        </label>
        <textarea
          className="harvest-log-textarea"
          id="comment"
          name="comment"
          placeholder="Comment"
        ></textarea>

        <div className="btn-add-product-container">
          <button
            className="btn"
            type="button"
            onClick={() =>
              setActiveLogProducts((prev) => [
                ...prev,
                { id: Date.now(), product: "", quantity: 0 },
              ])
            }
          >
            Add another product
          </button>
        </div>
        <div className="buttons-footer">
          <button type="reset" className="btn equal-btns" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn equal-btns"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
}
